import { Route } from 'react-router-dom';

import { SettingsFlowAuditLogView } from '../flow/views/auditLog';

import { SettingsPhoneView } from './settingsPhone.view';
import { SettingsPhoneEditFlowView } from './views/editFlow';

export const settingsPhoneRoutes = (
  <Route path="phone">
    <Route path="" element={<SettingsPhoneView />} />
    <Route path="flow/:flowId" element={<SettingsPhoneEditFlowView />} />
    <Route
      path="flow/:flowId/history"
      element={<SettingsFlowAuditLogView channel="phone" />}
    />
  </Route>
);
